// client/src/api/privacy/privacyApi.ts
//
// GDPR (Ott 2026): tracciabilità dell'accettazione dell'informativa privacy.
// - versione corrente pubblica: GET /api/privacy/policy
// - stato dell'utente:          GET /api/privacy/me/consent
// - accettazione:               POST /api/privacy/me/consent (versione scelta dal server)

import { boundApiFetch } from "../core/boundApiFetch";

export interface PrivacyPolicyInfo {
  version: string;
  effectiveDate: string;
  url: string;
}

export interface PrivacyConsentStatus {
  currentVersion: string;
  acceptedVersion: string | null;
  acceptedAt: string | null;
  lastAcceptedAt: string | null;
  needsAcceptance: boolean;
}

/** Versione corrente dell'informativa (endpoint pubblico). */
export function getPrivacyPolicy() {
  return boundApiFetch<PrivacyPolicyInfo>("/api/privacy/policy");
}

/** Stato del consenso dell'utente loggato. */
export function getPrivacyConsent() {
  return boundApiFetch<PrivacyConsentStatus>("/api/privacy/me/consent");
}

/** Registra l'accettazione della versione corrente dell'informativa. */
export function acceptPrivacyConsent() {
  return boundApiFetch<PrivacyConsentStatus>("/api/privacy/me/consent", {
    method: "POST",
    body: JSON.stringify({}),
  });
}
